import PropTypes from 'prop-types'
import Hyperlink from '../../../../shared/HyperLink'
import Image from 'next/image'

const AsFeaturedIn = ({ items }) => {
  return (
    <div
      className="gap-x-primary grid grid-cols-12"
      data-testid="featuredIn"
      id="featuredIn"
    >
      <h3 className="col-span-10 col-start-2 border-b border-gray-270 pb-2 text-center text-l font-bold leading-6.5 text-blue-700">
        As featured in
      </h3>
      <div
        className="col-span-10 col-start-2 mx-auto flex flex-wrap items-center justify-center md:w-9/12 lg:w-full lg:justify-between"
        data-testid="items"
      >
        {items.map((item, index) => {
          const { logo, name, alt, link } = item

          return (
            <Hyperlink
              href={link}
              key={index}
              clickTracking={true}
              alt={alt}
              childrenClassNames="w-1/2 pt-6 lg:w-auto"
            >
              <div className="relative mx-auto h-24 w-36" data-testid={name}>
                <Image
                  src={logo}
                  alt={alt}
                  fill
                  className="aspect-square object-contain"
                  sizes="(max-width: 640px) 100vw, 50vw"
                />
              </div>
            </Hyperlink>
          )
        })}
      </div>
    </div>
  )
}

AsFeaturedIn.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      alt: PropTypes.string,
      link: PropTypes.string,
      name: PropTypes.string,
      logo: PropTypes.string,
    })
  ),
}

AsFeaturedIn.defaultProps = {
  items: [],
}

export default AsFeaturedIn
